/* eslint-disable import/prefer-default-export */
import { DEFAULT_LOCATIONS, JBHUNT_NATIONAL, DROPDOWN } from 'utils/constants';
import { selectToken, EnvTokenMap } from 'utils/selectToken';
import { IndividualLocalClientConfig } from './localConfig.types';

export const apiTokens: EnvTokenMap = {
  dev: 'Token 95588f818757e7da3f376f8bf4c94a686bccc8dc',
  staging: 'Token e91550888abec3d2425011312d78470336364705',
  prod: 'Token 0bfafc3e9c35be4e898001601ddd04b22f1da4be',
};

const token = selectToken(apiTokens);

const jbhuntNationalConfig: IndividualLocalClientConfig = {
  CONFIG_NAME: 'jbhunt-national',

  API_TOKEN: token,
  EMBOLD_CLIENT: JBHUNT_NATIONAL,

  // login
  SHOW_REGION_SELECTOR: true,
  NETWORKS: {},

  // other
  DEFAULT_LOCATION: { ...DEFAULT_LOCATIONS.Lowell },
  LOGIN_NETWORK_NAME: 'jbhuntNationalUserId',

  // content
  DISPLAY_NAME: 'J.B. Hunt',
  FORM_VARIANT: DROPDOWN,
  NO_WELCOME_LINK: false,
};

export default jbhuntNationalConfig;
